export default __webpack_public_path__ + "static/media/spaceStation8.69003f62.webp";